import clsx from 'clsx';
import { useMemo } from 'react';

import { ImageSize, ProductWidget } from '@vestico/model';

import { ProductImage } from './ProductImage';
import style from './ProductsBannerMini.module.css';

export interface ProductsBannerMiniProps {
  products: ProductWidget[] | null | undefined;
  hasProduct: boolean;
  noShadow?: boolean;
  size?: 'normal' | 'small' | 'large';
}

export const ProductsBannerMini = ({ products, hasProduct, noShadow, size }: ProductsBannerMiniProps) => {
  const productMarkups = useMemo(() => {
    if (products === undefined) {
      return (
        <div className={clsx(style.product)}>
          <ProductImage product={undefined} size={ImageSize.xSmall} />
        </div>
      );
    }
    if (products === null) {
      return null;
    }

    const images = products.slice(0, 4).map((product, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <div key={`${product.documentID}-${index}`} className={clsx(style.product)}>
        <ProductImage product={product} size={ImageSize.xSmall} />
      </div>
    ));

    const count = images.length;

    if (count >= 3) {
      const imagesRight = images.splice(-2, 2);
      return [
        <div key="row1" className={clsx(style.row)}>
          {images}
        </div>,
        <div key="row2" className={clsx(style.row)}>
          {imagesRight}
        </div>,
      ];
    }

    return images;
  }, [products]);

  if (!hasProduct) {
    return null;
  }

  return (
    <div
      className={clsx(style.root, {
        [style.shadow]: !noShadow,
        [style.loading]: !products,
        [style.small]: size === 'small',
        [style.large]: size === 'large',
      })}
    >
      {productMarkups}
    </div>
  );
};
